import { LeaflyEnv } from "@leafly-com/lm-config";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();
export const isLocalDev = () =>
  publicRuntimeConfig.env === LeaflyEnv.LocalDev ||
  publicRuntimeConfig.env === ("ci" as LeaflyEnv);
